import { listSpecialties } from './listSpecialties'

export default {
  listSpecialties,
}
